/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { TTLCache } from './ttl-cache';

export interface IRequestVectorizerOptions {
    removalThresholdInMs?: number;
    intervalForRemovalInMs?: number;
}

/**
 * Class which handles vectorizing requests
 */
class RequestVectorizer {
    // differentiate vectors generated client/server side
    public static SEP: string = process.env.CURRENT_ENVIRONMENT === 'node' ? '.' : '/';
    private _cache: TTLCache<number>;

    constructor(options?: IRequestVectorizerOptions) {
        this._cache = new TTLCache(options);
        // binds
        this.next = this.next.bind(this);
    }

    /**
     * The next request in the sequence
     *
     * @param {string} requestId
     * @returns {string} the next vectorized request
     */
    public next(requestId: string): string {
        const value = this._cache.get(requestId);
        const nextValue = value === undefined ? 0 : value + 1;
        this._cache.set(requestId, nextValue);
        return `${requestId}${RequestVectorizer.SEP}${nextValue}`;
    }
}
const RequestVectorizerInstance = new RequestVectorizer();
export { RequestVectorizerInstance, RequestVectorizer };
